/**
 * Calculate default prices for a course based on total hours
 * @param {number} totalHours - Total hours of the course
 * @param {number} actualValue - Multiplier for actual price (default: 1.5)
 * @param {number} offerValue - Multiplier for offer price (default: 1)
 * @returns {Object} Object with actualPrice and offerPrice
 */
export const calculateDefaultPrices = (totalHours, actualValue = 1.5, offerValue = 1) => {
  const hours = totalHours || 0;
  return {
    actualPrice: Math.round(hours * 60 * actualValue),
    offerPrice: Math.round(hours * 60 * offerValue),
  };
};

/**
 * Get display prices for a course (uses default if prices are missing)
 * @param {Object} course - Course object
 * @param {number} actualValue - Multiplier for actual price (default: 1.5)
 * @param {number} offerValue - Multiplier for offer price (default: 1)
 * @returns {Object} Object with actualPrice and offerPrice
 */
export const getDisplayPrices = (course, actualValue = 1.5, offerValue = 1) => {
  const totalHours = course?.totalHours || 0;
  const defaultPrices = calculateDefaultPrices(totalHours, actualValue, offerValue);
  
  return {
    actualPrice: course?.actualPrice ?? defaultPrices.actualPrice,
    offerPrice: course?.offerPrice ?? defaultPrices.offerPrice,
  };
};

